<template>
  <div>
    <b-modal
      v-model="modalShow"
      ref="modalGroupView"
      size="xl"
      :title="modalTitle"
      hideFooter
    >
    <!--INIT Details Selector -->
      <b-card class="md-3">
        <b-row>
          <b-col>
            <GroupsDetails
              ref="groupDetails"
              @onClickExit="hideModal"
            ></GroupsDetails>
          </b-col>
        </b-row>
      </b-card>
      <!-- END Details Selector -->
    </b-modal>
  </div>
</template>

<script>
import GroupsDetails from "@/components/groups/GroupsDetails";

export default {
  name: "view-group-modal",
  components: {
    GroupsDetails,
  },
  data() {
    return {
      modalShow: false,
      modalTitle: "Agrupacion",
    };
  },
  methods: {
    showModal(id) {
      //Cargar datos genéricos
      this.modalShow = true;
      this.$refs.modalGroupView.show();

      //Force render
      if (id) {
        this.$nextTick(() => {
          // DOM updated
          this.$refs.groupDetails.retrieveGroupDetails(id);
        });
      }
    },

    hideModal() {
      this.modalShow = false;
    },
  },
};
</script>